/* eslint-disable react-hooks/exhaustive-deps */
import React, {useReducer, useEffect} from "react"
import {useEdularModulesContext, Modules} from "@edular/modules"
import {ApplicationProgress, Checklist} from "sections/shared/student"
import {handleError} from "helpers"
import {studentService} from "services"
import {useActiveTab, useHideFunnelInStudentDetails, useModel} from "hooks"
import {Tabs} from "antd"
import {useTranslation} from "react-i18next"
import ActivitiesTable from "sections/shared/student/ActivitiesTable/ActivitiesTable"
import WorkflowTriggersTable from "sections/Workflow/WorkflowTriggersTable"
import {TabHeader} from "components/Tab"
import {StudentNoteTab} from "sections/NewCommunication/shared"

const {TabPane} = Tabs

function reducer(state, action) {
    return {...state, ...action}
}

export enum FinAidStudentFinAidSubtab {
    Activities = "activities",
    WorkflowTriggers = "workflow-triggers",
    Checklist = "checklist",
    Notes = "notes"
}

const FinancialAidStudentTab = (props) => {
    const {studentId, departmentId} = props
    const {t} = useTranslation(["user", "common"])
    const initialState = {
        activeTabKey: "1",
        stageId: 0,
        currentStageId: 0,
        student: {profiles: [{}]}
    }
    const [{stageId, currentStageId}, dispatch] = useReducer(reducer, initialState)
    const [activeTabKey, onChangeTab] = useActiveTab(FinAidStudentFinAidSubtab.Activities, "finaidtab")
    const {isModuleEnable} = useEdularModulesContext()
    const model = useModel()
    const {hideFunnelInStudentDetails} = useHideFunnelInStudentDetails()

    async function loadStudent(studentProfileId: number) {
        try {
            const {
                data: [student]
            } = await studentService.getDepartmentStudents({filter: {profileIds: [studentProfileId], departmentId}})
            dispatch({student})
        } catch (error) {
            handleError(error)
        }
    }

    useEffect(() => {
        loadStudent(studentId)
    }, [])

    return (
        <div>
            {!hideFunnelInStudentDetails && <ApplicationProgress studentProfileId={studentId} />}
            <Tabs className="fullwidth klassSubTab" activeKey={activeTabKey} onChange={onChangeTab}>
                {isModuleEnable(Modules.ActivitiesAndFollowups) && (
                    <TabPane
                        tab={<TabHeader title={t("user.activities")} />}
                        key={FinAidStudentFinAidSubtab.Activities}>
                        <ActivitiesTable studentId={studentId} departmentId={departmentId} />
                    </TabPane>
                )}
                <TabPane
                    tab={<TabHeader title={t("user.workflowTriggers")} />}
                    key={FinAidStudentFinAidSubtab.WorkflowTriggers}>
                    <WorkflowTriggersTable profileId={studentId} departmentId={departmentId} />
                </TabPane>
                <TabPane tab={<TabHeader title={t("user.checklist")} />} key={FinAidStudentFinAidSubtab.Checklist}>
                    <Checklist studentId={studentId} departmentId={departmentId} />
                </TabPane>
                {model.isStaffOrAdmin() && (
                    <TabPane tab={<TabHeader title="Notes" />} key={FinAidStudentFinAidSubtab.Notes}>
                        <StudentNoteTab studentProfileId={studentId} />
                    </TabPane>
                )}
            </Tabs>
        </div>
    )
}

export default FinancialAidStudentTab
